export const popupConstants = {

    FETCH_POPUPS_REQUEST: 'FETCH_POPUPS_REQUEST',
    FETCH_POPUPS_SUCCESS: 'FETCH_POPUPS_SUCCESS',
    FETCH_POPUPS_FAILURE: 'FETCH_POPUPS_FAILURE',

    CREATE_POPUP_REQUEST: 'CREATE_POPUP_REQUEST',
    CREATE_POPUP_SUCCESS: 'CREATE_POPUP_SUCCESS',
    CREATE_POPUP_FAILURE: 'CREATE_POPUP_FAILURE',

    UPDATE_POPUP_REQUEST: 'UPDATE_POPUP_REQUEST',
    UPDATE_POPUP_SUCCESS: 'UPDATE_POPUP_SUCCESS',
    UPDATE_POPUP_FAILURE: 'UPDATE_POPUP_FAILURE',

    DELETE_POPUP_REQUEST: 'DELETE_POPUP_REQUEST',
    DELETE_POPUP_SUCCESS: 'DELETE_POPUP_SUCCESS',
    DELETE_POPUP_FAILURE: 'DELETE_POPUP_FAILURE',

}